import React from 'react'
import BaseIcon from 'react-icon-base'

import { IIconProps } from './interface'

const Delete = ({ pathProps, ...props }: { pathProps: {}; props: IIconProps }) => (
  <BaseIcon width="12" height="15" viewBox="0 0 12 15" {...props}>
    <path
      d="M11.762 2.547V.884H8.91L8.059.072H3.961l-.852.812H.24v1.663h11.523zM9.287 14.922c.449 0 .838-.165 1.168-.495.33-.33.495-.72.495-1.168v-9.9h-9.9v9.9c0 .449.165.838.495 1.168.33.33.72.495 1.168.495h6.574z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </BaseIcon>
)

export default Delete as React.FunctionComponent<IIconProps>
